/**
 * El enlace de acceso llega como /mi-sesion#t=TOKEN. El token se saca del
 * fragmento apenas carga la página y se borra de la barra de direcciones:
 * así no queda en el historial ni se copia sin querer al compartir la URL.
 *
 * Se guarda en sessionStorage, no en localStorage: dura lo que la pestaña.
 * Para volver otro día está el enlace del correo, que sigue sirviendo.
 */

const CLAVE_TOKEN = 'mentorking:token';

function almacen(): Storage | undefined {
  try {
    return window.sessionStorage;
  } catch {
    return undefined;
  }
}

/** Si la URL trae un token, lo guarda y lo quita de la URL. Devuelve el token vigente. */
export function tomarTokenDeLaUrl(): string | undefined {
  const m = /(?:^#|&)t=([A-Za-z0-9_-]{43})(?:&|$)/.exec(window.location.hash);
  if (m) {
    try {
      almacen()?.setItem(CLAVE_TOKEN, m[1]!);
    } catch {
      /* sin almacenamiento: el token vive solo en memoria */
    }
    window.history.replaceState(null, '', window.location.pathname + window.location.search);
    memoria = m[1];
    return m[1];
  }
  return tokenGuardado();
}

let memoria: string | undefined;

export function tokenGuardado(): string | undefined {
  try {
    return almacen()?.getItem(CLAVE_TOKEN) ?? memoria;
  } catch {
    return memoria;
  }
}

export function olvidarToken(): void {
  memoria = undefined;
  try {
    almacen()?.removeItem(CLAVE_TOKEN);
  } catch {
    /* nada que borrar */
  }
}

/**
 * El correo con que se hizo una reserva, para pasárselo al formulario de
 * pago sin pedirlo dos veces. La API no lo devuelve por el id (a propósito).
 */
export function recordarCorreo(reservaId: string, correo: string): void {
  try {
    almacen()?.setItem(`mentorking:correo:${reservaId}`, correo);
  } catch {
    /* opcional */
  }
}

export function correoDeReserva(reservaId: string): string | undefined {
  try {
    return almacen()?.getItem(`mentorking:correo:${reservaId}`) ?? undefined;
  } catch {
    return undefined;
  }
}

/**
 * La retención que este navegador tiene abierta, para soltarla si el cliente
 * vuelve atrás a cambiar su selección (y devolverle lo que había elegido).
 * Vive en la pestaña: otra pestaña u otro dispositivo no la tocan.
 */
export interface Retencion {
  id: string;
  fecha: string;
  horas: number[];
  tema?: string;
}

const CLAVE_RETENCION = 'mentorking:retencion';

export function recordarRetencion(r: Retencion): void {
  try {
    almacen()?.setItem(CLAVE_RETENCION, JSON.stringify(r));
  } catch {
    /* opcional */
  }
}

export function retencionGuardada(): Retencion | undefined {
  try {
    const x = almacen()?.getItem(CLAVE_RETENCION);
    return x ? (JSON.parse(x) as Retencion) : undefined;
  } catch {
    return undefined;
  }
}

export function olvidarRetencion(): void {
  try {
    almacen()?.removeItem(CLAVE_RETENCION);
  } catch {
    /* nada que borrar */
  }
}
